export default __webpack_public_path__ + "static/media/29t.3ec13255.jpg";